
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PageLayout extends Vue {
  get hasTopSlot() {
    return !!this.$slots["top"];
  }

  get hasHeaderSlot() {
    return !!this.$slots["header"];
  }

  get hasMainSlot() {
    return !!this.$slots["default"];
  }
}
